(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Always-open & non-collapsible on desktop (>= 990px). Re-apply after rerenders. */
(function() {
  const scopeSel = '#shopify-section-{{ section.id }}';
  function lockOpen() {
    const scope = document.querySelector(scopeSel);
    if (!scope) return;
    const vertical = scope.querySelector('.facets--vertical:not(.facets--drawer)');
    if (!vertical) return;

    vertical.querySelectorAll('.facets__panel').forEach(panel => {
      if (panel.tagName && panel.tagName.toLowerCase() === 'details') {
        panel.setAttribute('open', '');
        panel.addEventListener('toggle', () => { if (!panel.hasAttribute('open')) panel.setAttribute('open', ''); });
      }
    });
    vertical.querySelectorAll('.facets__summary').forEach(summary => {
      summary.setAttribute('aria-disabled', 'true');
      summary.style.pointerEvents = 'none';
    });
  }
  document.addEventListener('DOMContentLoaded', lockOpen);
  document.addEventListener('facets:updated', lockOpen);
  document.addEventListener('shopify:section:load', lockOpen);
  document.addEventListener('page:load', lockOpen);
})();

/* Sticky fallback: simulate pinning if layout kills native sticky */
(function() {
  const SECTION = document.querySelector('#shopify-section-{{ section.id }}');
  if (!SECTION) return;
  const mq = window.matchMedia('(min-width: 990px)');
  let sidebar, container, headerOffset, startY, width, containerBottomY;
  let usingFallback = false;

  function headerPx() {
    const rootVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const localVar = getComputedStyle(SECTION).getPropertyValue('--header-height').trim();
    const val = (localVar || rootVar || '80px').replace('px', '');
    const n = parseInt(val, 10);
    return isNaN(n) ? 80 : n;
  }

  function setup() {
    sidebar = SECTION.querySelector('.facets-block-wrapper--vertical');
    container = SECTION;
    if (!sidebar) return;

    headerOffset = headerPx();
    container.style.position ||= 'relative';

    sidebar.style.position = '';
    sidebar.style.top = '';
    sidebar.style.bottom = '';
    sidebar.style.width = '';
    sidebar.style.left = '';
    sidebar.style.right = '';

    const rect = sidebar.getBoundingClientRect();
    startY = rect.top + window.scrollY - headerOffset;
    width = rect.width;

    const c = container.getBoundingClientRect();
    containerBottomY = c.top + window.scrollY + c.height;
  }

  function onScroll() {
    if (!mq.matches || !sidebar) return;

    const shouldPin = window.scrollY >= startY;
    if (!shouldPin) {
      if (usingFallback) {
        sidebar.style.position = 'sticky';
        sidebar.style.top = headerOffset + 'px';
        sidebar.style.width = '';
        sidebar.style.left = '';
        usingFallback = false;
      }
      return;
    }

    const maxBeforeClamp = containerBottomY - (sidebar.offsetHeight + headerOffset);
    if (window.scrollY >= maxBeforeClamp) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = 'auto';
      sidebar.style.bottom = '0';
      sidebar.style.left = '';
      sidebar.style.width = width + 'px';
      usingFallback = true;
    } else {
      sidebar.style.position = 'fixed';
      sidebar.style.top = headerOffset + 'px';
      sidebar.style.width = width + 'px';
      const rect = sidebar.getBoundingClientRect();
      sidebar.style.left = rect.left + 'px';
      usingFallback = true;
    }
  }

  function reflow() { setup(); onScroll(); }
  document.addEventListener('DOMContentLoaded', () => {
    setup();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', reflow);
  });
  document.addEventListener('facets:updated', reflow);
  document.addEventListener('shopify:section:load', reflow);
  document.addEventListener('page:load', reflow);
})();
  } catch(e) { console.error(e); }
})();

})();
